// Scripts
import Modal from './Modal';
import ClipboardCopyButton from './ClipboardCopyButton';
import AjaxFilter from './AjaxFilter';
import AjaxForm from './AjaxForm';
import AjaxLink from './AjaxLink';
import AjaxSelect from './AjaxSelect';
import EnhancedEcommerce from './EnhancedEcommerce';
import EnhancedEcommerceProduct from './EnhancedEcommerceProduct';
import Toast from './Toast';
import Loader from './Loader';
import Viewer360 from './Viewer360';

window.Modal = Modal;
window.ClipboardCopyButton = ClipboardCopyButton;
window.AjaxFilter = AjaxFilter;
window.AjaxForm = AjaxForm;
window.AjaxLink = AjaxLink;
window.AjaxSelect = AjaxSelect;
window.EnhancedEcommerce = EnhancedEcommerce;
window.EnhancedEcommerceProduct = EnhancedEcommerceProduct;
window.Toast = new Toast();
window.Viewer360 = Viewer360;
window.Loader = new Loader();

function initComponents() {
    document.querySelectorAll('.maier-viewer-360').forEach((element) => {
        new Viewer360(JSON.parse(element.getAttribute('data-configuration')));
    })
}

function setupComponents() {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            initComponents();
        })
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupComponents);
} else {
    setupComponents();
}

require('./components/all');
require('./widgets/all');
require('./wrappers/all');

require('./dynamic-script-load');
require('./enhanced-ecommerce');
require('./maier-header');
require('./menu-display');
require('./netreviews-slick');
require('./product-search');
require('./retailer-clock');
require('./widget-avis-verifies');